<template>
  <div class="field no-select">
    <label
      v-if="label"
      class="mb-2 label no-select"
      :for="name"
    >
      <h3>{{ label }}</h3>
    </label>
    <DatePicker
      v-model="model"
      class="date-picker"
      :mode="mode"
      :model-config="{
        type: 'string',
        mask: 'iso',
      }"
      color="teal"
      :attributes="[
        {
          key: 'today',
          highlight: {
            color: 'teal',
            fillMode: 'outline',
          },
          dates: new Date(),
        },
      ]"
      is24hr
    >
      <template #default="{ inputValue, inputEvents }">
        <div class="datepicker-wrapper">
          <span class="datepicker-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              width="16"
              height="16"
            >
              <path
                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
              ></path>
            </svg>
          </span>
          <input
            :id="name"
            :value="inputValue"
            class="form-control"
            :disabled="isDisabled"
            v-on="inputEvents"
          />
        </div>
      </template>
    </DatePicker>
    <button
      v-show="isClearable"
      type="button"
      class="btn-field-action"
      :disabled="isDisabled"
      @click="clear()"
    >
      Limpar
    </button>
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

import commonProperties from './common-properties';

export default {
  name: 'DatetimePicker',
  components: {
    DatePicker,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    enableTime: {
      type: Boolean,
      default: false,
    },
    isClearable: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: 'datetime',
    },
  },
  mounted() {},
  methods: {
    clear() {
      this.model = null;
    },
  },
};
</script>

<style lang="scss">
.field {
  .date-picker {
    width: 100%;
    display: block;

    .vc-popover-content-wrapper {
      z-index: 1000;
    }
  }
  .vc-date {
    display: none;
  }
}
</style>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-small;
  line-height: 18px;
  color: $crm-blue-primary;
}

input.form-control {
  height: auto;
  background-color: $lighter;
  border: 1px solid $light;
  color: $darker;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 10px 16px;

  &:focus {
    border-color: $crm-blue-primary;
  }
}

.btn-field-action {
  background-color: transparent;
  border: 0;
  color: $crm-blue-primary;
  font-size: $size-smaller;
  margin: 0;
  padding: 0.5em 0;
}

.datepicker-wrapper {
  display: flex;

  .datepicker-icon {
    padding: 8px;
    border: 1px solid $crm-blue-primary;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    background: $crm-blue-light;

    svg {
      display: block;
      width: 16px;
      height: 100%;
      fill: $crm-blue-primary;
    }
  }
}
</style>
